import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import CreateUtilityForm from "../form/create/CreateUtilityForm";

interface IComponentProps {
	/**
	 * Close modal callback
	 */
	onClose: () => void
}

export default class CreateUtilityModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Create Utility"} autoWidth>
				<CreateUtilityForm closeModal={this.props.onClose}/>
			</Modal>
		);
	}
}
